import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    backgroundColor: "#F8F9FC",
    width: "100%",
    height: "100vh",
    overflow: "hidden"
  },
  content: {
    position: "relative",
    flex: 1,
    padding: theme.spacing(2),
    marginTop: theme.spacing(8),
    width: "100%",
    height: "calc(100% - 64px)",
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    [theme.breakpoints.down("md")]: {
      width: "calc( 100% - 82px )"
    },
    "& h4": {
      [theme.breakpoints.down("md")]: {
        fontSize: 24
      }
    }
  },
  contentShift: {
    marginTop: 0
  }
}));

export default useStyles;
